import React, { useState, useRef } from "react";
import "../../css/designSystem/Accordion.css";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as ArrowUp } from "../../assets/icons/arrow_up.svg";

const Accordion = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);

  return (
    <div className={`accordion${open ? " open" : ""}`}>
      <div className={`accordion-header-wrapper${open ? " open" : ""}`}>
        <button className="accordion-header" onClick={() => setOpen(!open)}>
          <span className="subtitle-semibold">{title}</span>
          <span className="accordion-icon">
            {open ? <ArrowUp /> : <ArrowDown />}
          </span>
        </button>
      </div>
      <div
        className={`accordion-content-wrapper${open ? " open" : ""} accordion-content`}
        ref={contentRef}
        style={{
          maxHeight: open
            ? `${contentRef.current?.scrollHeight || 0}px`
            : "0px",
          opacity: open ? 1 : 0,
        }}
      >
        <div className="content text-primary-1" >{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
